/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreApiService } from '../core-api-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ChangedEvent } from '../models/changed-event';
import { getLinkChangedEvents } from '../fn/routers-events/get-link-changed-events';
import { GetLinkChangedEvents$Params } from '../fn/routers-events/get-link-changed-events';
import { getStateChangedEvents } from '../fn/routers-events/get-state-changed-events';
import { GetStateChangedEvents$Params } from '../fn/routers-events/get-state-changed-events';
import { LinkChanged } from '../models/link-changed';

@Injectable({ providedIn: 'root' })
export class RoutersEventsAPI extends CoreApiService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLinkChangedEvents()` */
  static readonly GetLinkChangedEventsPath = '/routers/events/linkChanged';

  /**
   * Returns a stream of link changed events.
   *
   * Returns a SSE stream of link changed events for routers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLinkChangedEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLinkChangedEvents$Response(params?: GetLinkChangedEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<LinkChanged>> {
    return getLinkChangedEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns a stream of link changed events.
   *
   * Returns a SSE stream of link changed events for routers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLinkChangedEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLinkChangedEvents(params?: GetLinkChangedEvents$Params, context?: HttpContext): Observable<LinkChanged> {
    return this.getLinkChangedEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<LinkChanged>): LinkChanged => r.body)
    );
  }

  /** Path part for operation `getStateChangedEvents()` */
  static readonly GetStateChangedEventsPath = '/routers/events/stateChanged';

  /**
   * Returns a stream of state changed events.
   *
   * Returns a SSE stream of state changed events for routers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStateChangedEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStateChangedEvents$Response(params?: GetStateChangedEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangedEvent>> {
    return getStateChangedEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns a stream of state changed events.
   *
   * Returns a SSE stream of state changed events for routers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStateChangedEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStateChangedEvents(params?: GetStateChangedEvents$Params, context?: HttpContext): Observable<ChangedEvent> {
    return this.getStateChangedEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChangedEvent>): ChangedEvent => r.body)
    );
  }

}
